import { motion } from "framer-motion";

// MoodPunk Logo Component with distinct "D"
// The "D" has a slight visual difference to distinguish it from "O"
export const MoodPunkLogo = ({ 
  size = "md", 
  animate = false,
  className = "" 
}) => {
  const sizes = {
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-3xl",
    xl: "text-4xl"
  };

  const textClass = sizes[size] || sizes.md;

  const Logo = (
    <span className={`font-orbitron tracking-wider ${textClass} ${className}`}>
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-cyan-400">MOO</span>
      <span 
        className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-neon-purple relative"
        style={{ 
          fontWeight: 700,
          letterSpacing: '0.08em',
          textShadow: '0 0 10px rgba(168, 85, 247, 0.5)'
        }}
      >
        D
      </span>
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-purple to-neon-pink">PUNK</span>
    </span>
  );

  if (animate) {
    return (
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {Logo}
      </motion.div>
    );
  }

  return Logo;
};

// Alternative: Logo with underline on D
export const MoodPunkLogoAlt = ({ 
  size = "md",
  className = "" 
}) => {
  const sizes = {
    sm: "text-lg",
    md: "text-2xl", 
    lg: "text-3xl",
    xl: "text-4xl"
  };

  const textClass = sizes[size] || sizes.md;

  return (
    <span className={`font-orbitron tracking-wider ${textClass} ${className}`}>
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-purple">MOO</span>
      <span 
        className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-purple relative inline-block"
      >
        D
        <span 
          className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-neon-cyan to-neon-purple"
          style={{ transform: 'translateY(2px)' }}
        />
      </span>
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-purple">PUNK</span>
    </span>
  );
};

export default MoodPunkLogo;
